module.exports = "### Forecast Toggle\nAt any point, how a reader views the forecast can be toggled using the _Floating Action Button_ on the bottom left of the screen. On desktop it reveals a pop-up modal, on mobile it reveals a drawer.\n\n```image\nlight: true\nplain: true\nspan: 4\nsrc: \"/screens/DESK/2-P_forecast@2x.png\"\n```\n```image\nlight: true\nplain: true\nspan: 2\nsrc: \"/screens/MOB/2-P_forecast@2x.png\"\n```\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./catalog/pages/toggle.md
// module id = 796
// module chunks = 1